import React from 'react';

import LeftArrowSvg from 'assets/images/left-arrow.svg';

import BaseIcon from './BaseIcon';

const LeftArrowIcon = props => (
  <BaseIcon {...props} src={LeftArrowSvg} />
);

export default LeftArrowIcon;
